import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { Col, Container, Form } from "react-bootstrap";
import { useHistory } from "react-router";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import _ from "lodash";
import { useForm } from "react-hook-form";
import * as axiosInstance from "../../../services/axiosInstance";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import NotificationMessage from "../../../utils/NotificationMessage";
import LoadingOverlay from "../../../components/LoadingOverlay";
import useEDepositData from "../../../hooks/useEDepositData";
import {  useSelector } from "react-redux";
import ManualTransferTable from "../components/ManualTransferTable";
import PAGE from "../../../utils/Destination";
import {useLocation} from "react-router-dom";
import ManualTransferRemark from "../../EPayment/ManualTransferRemark";

function DepositManual({ label, items, onSubmitSetOff }) {
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const [loading, setLoading] = useState(false);
  const [payment, setPayment] = useState(1);
  const [currentDeposit, setCurrentDeposit] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const manualTransferRef = useRef(null);
  const location = useLocation();
  const postData = location.state;
  const postAccountId = _.get(postData, ["selectedAccountId"], null);
  const postSelectedCurrency = _.get(postData, ["selectedCurrencyId"], null);
  let history = useHistory();
  const { data, error, isLoading } = useEDepositData(token);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }
  const handleUploadClick = (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    } else {
      NotificationMessage.error("File input element not found.");
    }
  };

  const onSubmit = async (values) => {
    let formData = new FormData(manualTransferRef.current);
    setLoading(true);

    try {
      const response = await axiosInstance.post(
        "clientarea/deposit/manual-payment",
        formData,
        false,
        false,
        "",
        {
          "Content-Type": "multipart/form-data",
        },
      );
      if (response && response.status) {
        history.push(PAGE.DEPOSIT_TRANSACTION);
      }
    } catch (error) {
      const errorResponse = _.get(error, ["data", "errors"], null);
      if (errorResponse) {
        _.forEach(errorResponse, (item, itemMessage) => {
          setError(itemMessage, { type: "manual", message: item });
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const onError = () => {};

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    setError,
    getFieldState,
    reset,
    watch
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    defaultValues: {client_code:postAccountId,currency_code:postSelectedCurrency && postSelectedCurrency.key},
  });

  const onClickAddNew = (e) => {
    e.preventDefault();
    setPayment((prev) => prev + 1);
  };

  const removeDeposit = (e) => {
    e.preventDefault();
    let newItems = getValues("items");
    newItems = _.filter(newItems, (item, index) => index !== currentDeposit);
    setValue("items", newItems);
    setDeleteModal(false);
    setCurrentDeposit(null);
    setPayment((prev) => prev - 1);
  };

  const openDeleteModal = (e, index) => {
    e.preventDefault();
    setCurrentDeposit(index);
    setDeleteModal(true);
  };

  const onChangeAmount = (e) => {
    let newItems = getValues("items");
    setValue(
      "amount",
      _.sumBy(newItems, (item) => {
        return Number(_.get(item, ["amount"], 0));
      }),
    );
  };

  return (
      <Container fluid>
        <div
            className={"primary-border-table-border"}
            style={{backgroundColor: "white"}}
        >
          <div
              className={clsx(
                  "custom-card-label-container text-center d-flex justify-content-center align-items-center",
              )}
          >
            <div
                className={clsx("d-flex justify-content-center")}
                style={{flex: 1}}
            >
              <h2>Deposit Manual Transfer</h2>
            </div>
            <button
                className={clsx("btn custom-button-fill-light")}
                onClick={onClickAddNew}
            >
              Add New Deposit
            </button>
          </div>
          <br/>

          <div className={clsx("custom-table-info-container padding-12px")}>
            <Form
                ref={manualTransferRef}
                onSubmit={handleSubmit(onSubmit, onError)}
            >
              <div className={"responsive-table-border"}>
                <ManualTransferTable
                    config={data}
                    setValue={setValue}
                    payment={payment}
                    setPayment={setPayment}
                    handleUploadClick={handleUploadClick}
                    onClickAddNew={onClickAddNew}
                    register={register}
                    formValues={getValues}
                    removeDeposit={openDeleteModal}
                    onChangeAmount={onChangeAmount}
                    errors={errors}
                    watch={watch}
                    currency_code={postSelectedCurrency && postSelectedCurrency.key}
                    currency_symbol={
                        postSelectedCurrency && postSelectedCurrency.text
                    }
                />
              </div>
              <div className="d-flex justify-content-center py-3">
                <button
                    className={clsx("btn custom-button-back")}
                    onClick={(e) => {
                      e.preventDefault();
                      reset();
                    }}
                >
                  Reset
                </button>
                <button
                    className={clsx("btn custom-button-primary")}
                    type="submit"
                    style={{backgroundColor: "#9D7905"}}
                >
                  Submit
                </button>
              </div>
              <LoadingOverlay loading={loading}></LoadingOverlay>
            </Form>
          </div>
        </div>
        <ManualTransferRemark></ManualTransferRemark>
        <Modal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            centered={true}
        >
          <Modal.Body>Are you confirm to delete this deposit detail?</Modal.Body>
          <Modal.Footer style={{justifyContent: "flex-end"}}>
            <Button variant="secondary" onClick={() => setDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={(e) => removeDeposit(e)}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
  );
}

export default DepositManual;
